import { render, staticRenderFns } from "./seckillPrice.vue?vue&type=template&id=d8e13762&scoped=true&"
import script from "./seckillPrice.vue?vue&type=script&lang=js&"
export * from "./seckillPrice.vue?vue&type=script&lang=js&"
import style0 from "./seckillPrice.vue?vue&type=style&index=0&id=d8e13762&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e13762",
  null
  
)

export default component.exports